{
    "SkyraSurvey.Tittel": "Optional survey",
    "SkyraSurvey.Takk": "Thank you for answering the survey"
}
